module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/towel-32f83f9b4970a4861f9279fc77bcb8ea.svg";